<div class="sidebar-shell relative h-full z-[60] overflow-x-hidden" [class.mobile-viewport]="isMobileViewport()">
  @if (isMobileViewport()) {
    <button
      type="button"
      class="sidebar-backdrop fixed inset-0 border-0 opacity-0 pointer-events-none"
      [class.visible]="mobileOpen()"
      aria-hidden="true"
      tabindex="-1"
      aria-label="Cerrar menú lateral"
      (click)="closeMobile()"
    ></button>
  }

  <aside
    #sidebarPanel
    [ngClass]="isMobileViewport()
      ? 'w-[min(88vw,20rem)] min-w-[min(88vw,20rem)] max-w-[min(88vw,20rem)]'
      : showExpandedLayout
        ? 'w-[18rem] min-w-[18rem] max-w-[18rem]'
        : 'w-16 min-w-16 max-w-16'"
    class="sidebar relative z-[1] h-full overflow-hidden border-r-0 shadow-none shrink-0"
    [class.closed]="!showExpandedLayout"
    [class.mobile]="isMobileViewport()"
    [class.mobile-open]="mobileOpen()"
    [attr.aria-hidden]="isMobileViewport() && !mobileOpen() ? 'true' : 'false'"
  >
    <div class="sidebar-inner flex h-full flex-col p-3 align-middle">
      <div class="sidebar-head flex items-center justify-between gap-2 px-1">
      @if (showExpandedLayout) {
          <div class="brand-block flex items-center justify-start flex-auto min-w-0 overflow-hidden pl-0 pr-12">
            <img
              src="assets/ie-pos-logo-complete-small.png"
              alt="IE POS"
              class="brand-logo block w-auto max-w-none object-contain rounded-none p-0 brand-logo--light"
              width="384"
              height="256"
            />
            <img
              src="assets/ie-pos-logo-complete-dark-small.png"
              alt="IE POS"
              class="brand-logo block w-auto max-w-none object-contain rounded-none p-0 brand-logo--dark"
              width="384"
              height="256"
            />
          </div>
          <button
            type="button"
            (click)="toggle()"
            [attr.aria-label]="isMobileViewport() ? 'Cerrar menú lateral' : 'Colapsar menú lateral'"
            class="toggle-btn inline-flex items-center justify-center w-8 h-8 border-0"
          >
            <span
              [class]="isMobileViewport() ? 'fa-solid fa-xmark text-lg' : 'fa-solid fa-chevron-left text-sm'"
            ></span>
          </button>
      } @else if (!isMobileViewport()) {
        <button
          type="button"
          (click)="toggle()"
          aria-label="Abrir menú lateral"
          class="toggle-btn inline-flex items-center justify-center w-8 h-8 border-0 compact mx-auto"
        >
          <span class="fa-solid fa-bars text-sm"></span>
        </button>
      }
      </div>

      <div class="sidebar-divider w-full h-px"></div>

      <nav class="sidebar-menu m-0 p-0 mx-0" aria-label="Menú principal">
        <button
          type="button"
          class="quick-sale-btn flex items-center text-left"
          [ngClass]="showExpandedLayout
            ? 'w-full gap-3 rounded-xl px-3 py-2.5 sm:gap-3.5 sm:px-3.5 sm:py-2.5'
            : 'mx-auto h-11 w-11 justify-center rounded-xl p-0'"
          [class.collapsed]="!showExpandedLayout"
          [class.active]="isQuickSaleActive"
          [attr.title]="!showExpandedLayout ? 'Nueva venta' : null"
          [attr.aria-current]="isQuickSaleActive ? 'page' : null"
          (click)="navigate(quickSalePath)"
        >
          <span
            [ngClass]="showExpandedLayout
              ? 'quick-sale-icon-slot inline-flex h-8 w-8 shrink-0 items-center justify-center sm:h-9 sm:w-9'
              : 'quick-sale-icon-slot inline-flex h-8 w-8 shrink-0 items-center justify-center'"
          >
            <i class="fa-solid fa-receipt quick-sale-icon text-sm"></i>
          </span>

          @if (showExpandedLayout) {
            <span class="quick-sale-label truncate text-sm font-semibold sm:text-[0.94rem]">
              Nueva venta
            </span>
          }
        </button>

        <ul class="menu-root w-full">
          <ng-container
            *ngTemplateOutlet="renderNodes; context: { $implicit: visibleTree(), level: 0 }"
          ></ng-container>
        </ul>
      </nav>
    </div>
  </aside>
</div>

<!-- Template de nodos recursivos -->
<ng-template #renderNodes let-nodes let-level="level">
  @for (item of nodes; track item.id) {
<li
  class="menu-node w-full"
  [class.expanded]="isExpanded(item.id)"
  [style.--level]="level"
>
  <div
    class="menu-row cursor-pointer w-full relative group"
    [class]="showExpandedLayout ? 'grid grid-cols-[1.25rem_1fr_auto] items-center' : 'flex justify-center items-center'"
    [class.active]="isActive(item)"
    [class.parent-active]="inActiveBranch(item)"
    [class.menu-item--locked]="isLocked(item)"
    [class.menu-item--soon]="isComingSoon(item)"
    [attr.title]="getItemTitle(item)"
    [attr.aria-current]="isActive(item) ? 'page' : null"
    [attr.aria-expanded]="hasChildren(item) ? isExpanded(item.id) : null"
    tabindex="0"
    (click)="onClick(item)"
    (keydown.enter)="onClick(item)"
    (keydown.space)="onClick(item); $event.preventDefault()"
  >
    <!-- Overlay único para todos los estados -->
    <div class="overlay"></div>

    <!-- Col 1: icono -->
    <span class="glyph flex items-center justify-center relative z-10">
      <i [class]="item.icon || ''" class="opacity-90 leading-none"></i>
    </span>

    <!-- Col 2: label (solo abierto) -->
    @if (showExpandedLayout) {
      <span class="label truncate whitespace-nowrap block pr-2 relative z-10">
        {{ item.name }}
      </span>

      @if (getItemBadgeLabel(item); as badgeLabel) {
        <span
          class="menu-item-badge inline-flex items-center justify-center ml-auto rounded-full font-bold leading-none whitespace-nowrap relative z-10"
          [class.menu-item-badge--soon]="isComingSoon(item)"
          [class.menu-item-badge--locked]="isLocked(item)"
        >
          {{ badgeLabel }}
        </span>
      }
    }

    <!-- Col 3: chevron (solo abierto y con hijos) -->
    @if (showExpandedLayout && hasChildren(item)) {
      <span class="relative z-10 justify-self-end self-center pr-1 flex items-center">
        <i
          class="chevron fa-solid fa-chevron-right transition-transform duration-200 inline-block leading-none"
          [style.transform]="isExpanded(item.id) ? 'rotate(90deg)' : 'rotate(0deg)'"
        ></i>
      </span>
    } @else if (showExpandedLayout) {
      <span class="chevron-spacer relative z-10 justify-self-end self-center pr-1" aria-hidden="true"></span>
    }

  </div>

  @if (hasChildren(item)) {
    <ul
      class="submenu w-full"
      [class.submenu--open]="showExpandedLayout && isExpanded(item.id)"
      [attr.aria-hidden]="!(showExpandedLayout && isExpanded(item.id)) ? 'true' : null"
    >
      <li class="submenu-inner overflow-hidden min-h-0 list-none p-0 m-0">
        <ul class="w-full list-none p-0 m-0">
          <ng-container
            *ngTemplateOutlet="renderNodes; context: { $implicit: item.childrenItems, level: level + 1 }"
          ></ng-container>
        </ul>
      </li>
    </ul>
  }
</li>
  }
</ng-template>
